import { CSSProperties } from "react";
import {
  AgentEffectDescription,
  BattleCard,
  battleCardsDefRepository,
} from "~/business";
import { FontSize, Sizes, Spacing } from "~/jsx/theme";
import { XAgentEffect } from "./XAgentEffect";
import { XTypography } from "./XTypography";
import { Proposition } from "~/utils";

const ranks = ["1st", "2nd", "3rd"];

export const XBattleCard = ({
  card,
  style,
  rightElements = [],
}: {
  card: BattleCard;
  style?: CSSProperties;
  rightElements?: React.ReactNode[];
}) => {
  const { ratio, width, radius } = Sizes.battleCard;
  const cardProps = card.getDef(battleCardsDefRepository);
  const { name, effects } = cardProps;
  const rankHeights = [75, 60, 60];
  const cardPadding = 12;
  const rankGap = Spacing.px4;

  return (
    <div
      style={{
        borderRadius: radius,
        backgroundColor: "#250810",
        width,
        maxWidth: width,
        height: width * ratio,
        padding: cardPadding,
        display: "flex",
        ...style,
      }}
    >
      <XTypography
        style={{
          marginRight: 2,
        }}
        typographyStyle={{
          color: "#D6C8CA",
          textTransform: "uppercase",
          marginTop: 0,
          writingMode: "vertical-rl",
          height: "100%",
          transform: "rotate(180deg)",
          fontSize: name.length >= 18 ? "15px" : "18px",
        }}
      >
        {name}
      </XTypography>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: rankGap,
          height: "100%",
          flex: 1,
        }}
      >
        {effects.map((rankEffects, index) => {
          return (
            <div
              key={index}
              style={{
                backgroundColor: "#A33C37",
                display: "flex",
                borderRadius: 4,
                justifyContent: "center",
                alignItems: "center",
                padding: 20,
                paddingRight: 10,
                paddingLeft: 25,
                position: "relative",
                height: rankHeights[index],
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  backgroundColor: "#653229",
                  borderRadius: "0 0 4px 0",
                  padding: Spacing.px4,
                }}
              >
                <XTypography
                  style={{ color: "#C59894", fontSize: FontSize.px12 }}
                >
                  {ranks[index]}
                </XTypography>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: rankEffects.some((effect) =>
                    Proposition.isImplicationProposition(effect)
                  )
                    ? "column"
                    : "row",
                }}
              >
                {rankEffects.map((effect, index2) => {
                  return (
                    <XAgentEffect
                      key={index2}
                      context="battleCard"
                      effectDescription={effect}
                      width={
                        rankEffects.length === 1
                          ? 30
                          : rankEffects.length === 2
                          ? 28
                          : 24
                      }
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      {rightElements.map((element, index) => {
        return (
          <div
            key={index}
            style={{
              position: "absolute",
              height: rankHeights[index],
              right: 0,
              top:
                [...new Array(index)]
                  .map((_, index2) => rankHeights[index2] + rankGap)
                  .reduce((acc, i) => acc + i, 0) + cardPadding,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {element ?? null}
          </div>
        );
      })}
    </div>
  );
};
